import { useState } from 'react';

import { FlightHUDWidgetProps } from '../pilot/components/FlightHUDWidget';

export interface TelemetryState {
  lat: number;
  lon: number;
  gimbalPitch: number;
  gimbalYaw: number;
  altitude: number;
  horizontalSpeed: number;
  verticalSpeed: number;
  heading: number;
  windSpeed: number;
  windDirection: number;
  batteryPercent: number;
  estTimeToHome: string;
  estTimeUntilLowBattery: string;
  distanceToHome: number;
  roll: number;
  pitch: number;
  zoom: number;
}

export const defaultTelemetryState: TelemetryState = {
  lat: 37.789,
  lon: -122.4384,
  gimbalPitch: -45,
  gimbalYaw: 180,
  altitude: 200,
  horizontalSpeed: 15,
  verticalSpeed: 0,
  heading: 0,
  windSpeed: 5,
  windDirection: 0,
  batteryPercent: 75,
  estTimeToHome: '05:00',
  estTimeUntilLowBattery: '15:00',
  roll: 0,
  pitch: 0,
  zoom: 1,
  distanceToHome: 100
};

export const useSimulatorTelemetry = (initial: TelemetryState = defaultTelemetryState) => {
  const [telemetry, setTelemetry] = useState<TelemetryState>(initial);
  const reset = () => setTelemetry(initial);
  return { telemetry, setTelemetry, reset };
};

export const toHudProps = (telemetry: TelemetryState): FlightHUDWidgetProps => ({
  gimbalPitch: telemetry.gimbalPitch,
  gimbalYaw: telemetry.gimbalYaw,
  distanceToHome: telemetry.altitude,
  horizontalSpeed: telemetry.horizontalSpeed,
  verticalSpeed: telemetry.verticalSpeed,
  heading: telemetry.heading,
  windSpeed: telemetry.windSpeed,
  windDirection: telemetry.windDirection,
  batteryPercent: telemetry.batteryPercent,
  estTimeToHome: telemetry.estTimeToHome,
  estTimeUntilLowBattery: telemetry.estTimeUntilLowBattery,
  roll: telemetry.roll,
  pitch: telemetry.pitch,
  zoom: telemetry.zoom
});
